<script setup>
import { computed, ref } from 'vue';
import { dateHelper } from '@shop/frontend/web/js/helpers/dateHelper';
import ITeams from '../ITeams/ITeams.vue';

const props = defineProps({
  packageEvent: {
    type: Object,
    required: true,
  },
});

const eventFormattedDate = ref(
  dateHelper.getFormattedDate(props.packageEvent.startTimestamp, 'DD.MM.YYYY dd HH:mm'),
);

const eventNameForMobile = computed(() => {
  return `${props.packageEvent.participants.team.homeTeam.name} - ${props.packageEvent.participants.team.guestTeam.name}`
});

</script>

<template>
  <div class="i-package-event">
    <ITeams
      v-if="packageEvent.participants?.team"
      class="i-package-event__teams"
      :first-team="packageEvent.participants.team.homeTeam"
      :second-team="packageEvent.participants.team.guestTeam"
    />
    <div class="i-package-event__name">
      {{ eventNameForMobile }}
    </div>
    <div class="i-package-event__details">
      <span class="i-package-event__detail i-package-event__detail_date">
        <svg width="18" height="18">
          <use xlink:href="#calendar" />
        </svg>
        <span class="text-capitalize">{{ eventFormattedDate }}</span>
      </span>
      <span class="i-package-event__detail">
        <svg width="18" height="18">
          <use xlink:href="#location" />
        </svg>
        {{ packageEvent.unitName }}
      </span>
    </div>
  </div>
</template>

<style lang="scss">
.i-package-event {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 10px 16px;
  background-color: #F7F7FC;
  border-radius: 15px;

  &__details {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__detail {
    display: flex;
    gap: 8px;
    font-weight: 500;
    font-size: 14px;
  }

  &__detail_date {
    color: $primary;
  }

  &__name {
    display: none;
  }

  .i-teams {
    min-width: 48%;
    margin-bottom: 0;
    flex-grow: 0;
  }

  @media (max-width: $screen-xs) {
    align-items: baseline;
    flex-direction: column;
    gap: 16px;

    &__teams {
      display: none;
    }

    &__name {
      display: block;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>
